// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"56e64549","908":"1f3783fd","943":"3ad0d681"}[chunkId] + ".chunk.css";
};